import "core-js/modules/es.string.ends-with";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/es.string.trim";

/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Esey Woldeabzghi
 *
 *Description:
*/
import React from 'react';
import CmsContent from '../../CmsContent';
import Block from '../../../block/Block';

var isParagraphWrapped = function isParagraphWrapped(text) {
  var markup = text.trim();
  return markup.startsWith('<p') && markup.endsWith('/p>');
};

export var Footnote = function Footnote(_ref) {
  var data = _ref.data;
  var text = data.component.content.text;
  var paragraphWrapped = isParagraphWrapped(text);

  if (paragraphWrapped) {
    return /*#__PURE__*/React.createElement(CmsContent, {
      content: text
    });
  } else {
    return /*#__PURE__*/React.createElement(Block, {
      el: "p"
    }, /*#__PURE__*/React.createElement(CmsContent, {
      content: text
    }));
  }
};
export default Footnote;